// Copyright (c) 2026 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { useMutation } from '@tanstack/react-query';
import { Party, Template } from '@daml/types';
import { useLedgerApiClient } from '../../../contexts/LedgerApiContext';
import { LedgerCreateArgs } from '../../../utils/LedgerApiClientV2';

export const useLedgerCreate = <T extends object, K, I extends string>(
  template: Template<T, K, I>,
) => {
  const ledgerApi = useLedgerApiClient();

  return useMutation({
    mutationKey: ['ledgerCreate'],
    mutationFn: async (args: LedgerCreateArgs<T>) => {
      let actAs: Party[] | undefined;
      let readAs: Party[] | undefined;

      if (args.submitter) {
        actAs = [args.submitter];
      } else {
        actAs = args.actAs;
        readAs = args.readAs;
      }

      return ledgerApi.create(template, args.argument, args.meta, actAs, readAs);
    },
  });
};
